<template>
  <div class="headroom-wrapper" style="height: 50px">
    <div class="headroom headroom--unfixed">
      <div id="navbar">
        <div id="nav-background" :class="navClass"></div>
        
        <a v-if="currentPage === 'work'" class="text-link after-animation">W O R K</a>
        <router-link v-else class="text-link" to="/work">W O R K</router-link>

        <a v-if="currentPage === 'home'" class="text-link after-animation">H O M E</a>
        <router-link v-else class="text-link" to="/">H O M E</router-link>

        <a v-if="currentPage === 'about'" class="text-link after-animation">A B O U T</a>
        <router-link v-else class="text-link" to="/about">A B O U T</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  currentPage: {
    type: String,
    required: true
  },
  navClass: {
    type: String,
    default: 'nav-general'
  }
});
</script>
